import { inputShippingInfo } from "./actions";
import { db, FirebaseTimestamp } from "../../firebase/index";
import { push } from "connected-react-router";

export const setShippingInfo = (receiver, furigana, telephone, postCode, prefecture, city, address, apartmentAndRoom) => {
    return async (dispatch) => {
        dispatch(inputShippingInfo({
            receiver: receiver,
            furigana: furigana,
            telephone: telephone,
            postCode: postCode,
            prefecture: prefecture,
            city: city,
            address: address,
            apartmentAndRoom: apartmentAndRoom,
        }))

        if (receiver !== "" && furigana !== "" && telephone !== "" &&
            postCode !== "" && prefecture !== "" && city !== "" && address !== "") {
            dispatch(push("/confirm-shipping-info"))
        }else{
            window.alert("必須項目が未入力です")
        }
    }
}

export const registerShippingInfo = (shippingName, furigana, telephone, postCode, prefecture, city, address, apartmentAndRoom, orderuuid) => {
    return async (dispatch) => {
        // validation
        if( shippingName === "" || furigana === "" || telephone === "" || postCode === "" || prefecture ==="" || city === "" || address === "") {
                window.alert("必須項目が未入力です")
                return false
        }

        const createdAt = FirebaseTimestamp.now()
        
        const shippingInfoData = {
            orderId: orderuuid,
            shippingName: shippingName,
            furigana: furigana,
            telephone: telephone,
            postCode: postCode,
            prefecture: prefecture,
            city: city,
            address: address,
            apartmentAndRoom: apartmentAndRoom,
            createdAt: createdAt
        }

        db.collection('ShippingInfo').doc().set(shippingInfoData)
            .then(() => {
                //console.log('success to register shipping info');
            })
    }
}